"use client";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";
import { FormField } from "@/schemas/type";
import { getCountry } from "@/server/user";
import { useCurrentLocale } from "@/hooks/useCurrentLocale";
import useSWR from "swr";
import { useFormContext, useWatch } from "react-hook-form";
import { useEffect } from "react";

interface FormSelectProps {
  field?: FormField;
  placeholder?: string;
  required?: boolean;
  className?: string;
  disabled?: boolean;
  level?: string;
  parent?: string;
  // eslint-disable-next-line no-unused-vars
  onLabelChange?: (label: string, id?: number) => void;
  isFetching?: boolean;
}

export default function FormLocation(props: FormSelectProps) {
  const locale = useCurrentLocale();

  const { control } = useFormContext<any>();

  const value = useWatch({
    control,
    name: props.field?.name || ""
  });

  const { data, isLoading } = useSWR(
    props.isFetching ? `/api/location/${props.level}/${props.parent}` : null,
    () =>
      getCountry({
        filter: {
          level: {
            _eq: props.level,
          },
          ...(props.level === "1" ? {} : { parent: { _eq: props.parent } }),
        },
        fields: "id,name,name_en,level,parent",
      })
  );

  useEffect(() => {
    
    if (!isLoading && props.field?.name) {
      const label = data?.data?.find((item) => item.id === Number(value));
      props?.onLabelChange?.(
        (locale === "cn" ? label?.name : label?.name_en) ?? "",
        label?.id
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, value, locale])

  return (
    <Select
      value={props.field?.value}
      onValueChange={(value) => {
        if (isLoading) return;

        props.field?.onChange?.(value);
      }}
      disabled={props?.disabled}>
      <SelectTrigger
        className={cn(
          "h-10 w-full rounded border-b border-[#F0F0F0] border-t-0 border-x-0 p-0 text-sm hover:border-[#FF5100] focus:border-[#FF5100] data-[disabled]:bg-[#F7F7F7] data-[placeholder]:text-[#A6A6A6] md:border md:border-[#C2C6CE] md:px-4",
          props.className
        )}>
        <SelectValue
          placeholder={
            <span
              className={cn(
                "after:pl-0.5 after:text-[#FF5100]",
                props.required ? "after:content-['*']" : ""
              )}>
              {props.placeholder}
            </span>
          }
        />
      </SelectTrigger>
      <SelectContent className="border-[#C2C6CE] bg-white">
        {data?.data?.map((option, index) => (
          <SelectItem key={index} value={String(option.id)}>
            {locale === "cn" ? option.name : option.name_en}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
